module.exports = __webpack_public_path__ + "img/Perfect-Fit-650x340.05be1a57.png";